import React, { useEffect, useState, useContext } from "react";
// import CC_flp from "../Includes/Layouts/ReEngagedFollowup/CC_flp.js";
import HP_flp from "../Includes/Layouts/ReEngagedFollowup/HP_flp.js";
import Loader from "../Includes/Layouts/ReEngagedFollowup/Loader";
import VisitorParamsContext from "../../Contexts/VisitorParams";
import { useFollowupLoad } from "../../Hooks/useFollowupLoad";
import { queryString } from "../../Utility/QueryString";
import { Api } from "../../api/Api";
import { useHistory } from "react-router-dom";
import { usePageLoad } from "../../Hooks/usePageLoad";
import { getPageName } from "../../Constants/PageNames";

const ReEngagedFollowupHirePurchase = () => {
  const [uuid, setUuid] = useState();
  const [userDetails, setUserDetails] = useState([]);
  const [currentComponent, setCurrentComponent] = useState("loader");
  const history = useHistory();
  const { visitorParameters } = useContext(VisitorParamsContext);
  const { loadFollowup } = useFollowupLoad();
  const { savePageLoad } = usePageLoad();
  const [pendingSlides, setPendingSlides] = useState([]);
  const [pendingQuestions, setPendingQuestions] = useState([]);
  const [followupData, setFollowupData] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const response = await Api.get(
          "/api/v1/followup/get-details-re_engage?query_string=" + queryString + "&re_engage_type=hp_flp&",
          {}
        );
        if (response.data.status === "Success") {
          const { uuid, followup_data, re_engaged_id, re_engaged_product_type, slides, pending_question } = response.data.response;
          followup_data.reengage_id = re_engaged_id;
          
          await pageStatus({
            uuid,
            page_name: "re_engage_loader",
            status: "visited",
            source: followup_data.atp_sub6,
            re_engaged_id: re_engaged_id,
          });

          setUserDetails(response.data.response);
          setUuid(uuid);
          setPendingQuestions(pending_question);
          setPendingSlides(slides);
          setFollowupData({ ...followup_data, re_engaged_id });
          localStorage.setItem("uuid", uuid);
          localStorage.setItem("flp_source", followup_data.atp_sub6);
          localStorage.setItem("followup_data", JSON.stringify(followup_data));
          localStorage.setItem("re_engagedId", re_engaged_id);
          localStorage.setItem("tms_display_name", response.data.response.tms_display_name);
          localStorage.setItem("cc_preview_data", JSON.stringify(response.data.response.previewdata));
          localStorage.setItem("product_type", re_engaged_product_type);

          localStorage.setItem("hp_preview_data", JSON.stringify(response.data.response.previewdata));
          
          const message_type = `reengage_${re_engaged_id}`;
          await loadFollowup("followup_load", followup_data, "re_engage_followup", queryString, message_type);

          setTimeout(async () => {
            setCurrentComponent(re_engaged_product_type === "Credit Card" ? "cc_flp" : "hp_flp");
          }, 3000);
        } else {
          localStorage.setItem("tms_display_name", response.data.response.tms_display_name);
          history.push("/re_engage_thankyou?uuid=" + response.data.response.uuid);
        }
      } catch (error) {
        console.error("Error loading re-engage followup:", error);
        history.push("/re_engage_thankyou?uuid=" + uuid);
      }
    })();
  }, []);

  useEffect(() => {
    if (pendingSlides === null) {
      history.push("/re_engage_thankyou?uuid=" + uuid);
    }
  }, [pendingSlides]);

  const pageStatus = async (pageDetails) => {
    const pageName = getPageName(pageDetails.page_name);
    const data = {
      uuid: pageDetails.uuid ?? uuid,
      page_name: pageName,
      status: pageDetails.status,
      source: pageDetails.source,
      re_engaged_id: pageDetails.re_engaged_id,
    };

    await savePageLoad(
      visitorParameters.visitor_parameters,
      data,
      "re_engaged_visited_status",
      pageName,
      queryString,
      visitorParameters.data,
    );
  };

  const renderCurrentComponent = () => {
    const commonProps = {
      uuid,
      userDetails,
      pageStatus,
      pendingSlides,
      pendingQuestions,
      followupData
    };

    switch (currentComponent) {
      case "loader":
        return <Loader showUserName={userDetails.user_fullname} />;
      
    //   // Render Credit Card FLP
    //   case "cc_flp":
    //     return <CC_flp {...commonProps} />;
      
      // Render Hire Purchase FLP
      case "hp_flp":
        return <HP_flp {...commonProps} />;
      
      default:
        return null;
    }
  };

  return (
    <>
      {renderCurrentComponent()}
    </>
  );
};

export default ReEngagedFollowupHirePurchase;
